import React from "react";
import styled from "styled-components";
import GithubIcon from "../assets/github.png";

const Github: React.FC = () => {
  return (
    <GithubLink
      href="https://github.com/nutthanonn/ctf-flag-generator"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon src={GithubIcon} alt="github" />
    </GithubLink>
  );
};

export default Github;

const GithubLink = styled.a`
  position: fixed;
  top: 1rem;
  right: 1rem;
  opacity: 0.5;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const Icon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;
